<template>
    <div>
        <base-crud
            crudName="Produtos"
            newText="Novo Produto"
            :table="productTable"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="false"
            :enableEdit="true"
            :enableDelete="false"
            :enableView="true"
            :boxUpload="true"
            :enableSetStatus="true"
        >
        </base-crud>

        <div class="modal fade" id="uploadBoxImage">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>Imagem da Caixa</h3>
                    </div>
                    <div class="modal-body p-sm">
                        <form action="" class="m-t-sm">
                            <div class="form-group">
                                <input type="file" id="photo">
                            </div>

                            <input type="hidden" id="id">
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" data-dismiss="modal">Cancelar <i class="fa fa-save"></i></button>
                        <button class="btn btn-success" @click="uploadBoxImage()">Salvar <i class="fa fa-save"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                productTable: 'productTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'product_id', 'subCategoryProduct', 'name', 'status', 'box_photo', 'photo', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'product_id', 'name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    templates: {
                        subCategoryProduct: function (h, row, index) {
                            return (row.sub_category_product) ? row.sub_category_product.description : row.sub_category_product
                        },
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    },
                    headings: {
                        'product_id': 'Produto',
                        'subCategoryProduct': 'Sub-Categoria do Produto',
                        'name': 'Nome',
                        'box_photo': 'Foto da Caixa',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    }
                },
                endPoint: 'product/'
            }
        },
        components: {
            BaseCrud
        },
        computed: {
            postUrl() {
                return this.$store.getters.api + this.endPoint;
            }
        },
        methods: {
            uploadBoxImage: function (){
                const self  = this;
                const api   = self.$store.state.api;

                // Modal Information
                const modal = $('#uploadBoxImage');
                const id    = modal.find('#id').val();

                let form  = new FormData();
                let photo = document.getElementById('photo');

                form.append('photo', (photo.files[0]) ? photo.files[0] : null);

                self.$http.post(api + 'product/' + id + '/image/box/upload', form)
                    .then((response) => {
                        $('#box-' + id).html(response.data);
                        modal.modal('hide');
                        self.$message('Sucesso', 'Upload realizado com sucesso', 'success');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            }
        }
    }
</script>

<style>

    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Product/Crud.vue